import { render, staticRenderFns } from "./PdaIndex.vue?vue&type=template&id=656938a2"
import script from "./PdaIndex.vue?vue&type=script&lang=js"
export * from "./PdaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports